import { FC } from "react"
import { SubscriptionDetails } from "../../../../../../../types"
import {
  CurrencyValueCell,
  OptionValueToNameCell,
  SectionCell
} from "../../../../../section"
import If from "../../../../../if"

interface Props {
  quote_info: SubscriptionDetails["quote_info"]
}

const LoanScenario: FC<Props> = ({
  quote_info,
  quote_info: {
    loan_amount,
    loan_purpose,
    loan_type,
    loan_term,
    arm_term,
    property_type,
    list_price,
    residency_type,
    credit_score,
    household_income
  }
}) => (
  <div className="grid sm:grid-cols-3 gap-4">
    <OptionValueToNameCell label="Loan purpose" value={loan_purpose} />

    <OptionValueToNameCell label="Loan type" value={loan_type} />

    <If
      condition={!!loan_term}
      then={<SectionCell label="Loan term" value={loan_term ?? ""} />}
    />
    <If
      condition={!!arm_term}
      then={<SectionCell label="Arm term" value={arm_term} />}
    />

    <CurrencyValueCell label="Loan amount" value={loan_amount} />
    <CurrencyValueCell label="Property value" value={list_price} />

    <If
      condition={!!household_income}
      then={
        <CurrencyValueCell
          label="Household income"
          value={household_income ?? 0}
        />
      }
    />

    <SectionCell label="Credit score" value={credit_score} />
    <OptionValueToNameCell label="Property type" value={property_type} />
    <OptionValueToNameCell label="Property usage" value={residency_type} />
  </div>
)

export default LoanScenario
